export const importTasksKanbanService = (fetch) => async (file) => {
  try {
    const formData = new FormData()
    formData.append("file", file);
    const response = await fetch({
      url: '/api/v1/plan-trabajo-capacitacion/importar-tareas',
      method: 'post',
      body: formData
    })

    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message)
  }
}
